import { useTheme, Typography } from '@mui/material';
import { UserCircle } from '@phosphor-icons/react';

import {
  FamilyMemberListItemStyled,
  FamilyMemberCircleStyled,
} from './FamilyMemberListItemStyled';

export interface FamilyMemberListItemProps {
  name: string;
}

export const FamilyMemberListItem = ({ name }: FamilyMemberListItemProps) => {
  const theme = useTheme();
  const altText = `${name} is covered`;
  const firstName = name.trim().split(' ')[0];
  const shortened =
    firstName.length > 6 ? `${firstName.slice(0, 4)}..` : firstName;

  return (
    <FamilyMemberListItemStyled data-testid="family-member-list-item">
      <FamilyMemberCircleStyled>
        <UserCircle
          size={24}
          color={theme.palette.primary.main}
          alt={altText}
        />
      </FamilyMemberCircleStyled>
      <Typography variant="body2">{shortened}</Typography>
    </FamilyMemberListItemStyled>
  );
};
